module.exports = __webpack_public_path__ + "static/media/prixa.35f08044.png";